import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {useOfferListingAbroadView} from "../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {useOfferListingHolidayView} from "../../offer/list/hooks/use_offer_listing_holiday_view_check";
import {useRecentFiltersWithSurvey} from "../hooks/use_recent_filters_with_survey";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {
    getRecentFilterFilterText,
    getRecentFilterSearchUrlWithFilters,
    getSurveyFilterText,
    getSurveySearchUrlWithFilters
} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {}

/**
 * Component to display survey preferences + recent filters from localStorage.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersSidebar = (props: IProps) => {
    const {className, style} = props;

    const {recentFilters, latestQuery, shouldShow, surveyFormValues, shouldShowSurvey, currentFormValues} = useRecentFiltersWithSurvey();

    const isAbroad = useOfferListingAbroadView();
    const isHoliday = useOfferListingHolidayView();

    if (isAbroad || isHoliday) {
        return null;
    }

    const hasAnyContent = (shouldShow && recentFilters.length > 0) || (shouldShowSurvey && !!surveyFormValues);

    if (!hasAnyContent) {
        return null;
    }

    return (
        <div className={cx(recentFiltersListWrapperStyle, className)} style={style}>
            {shouldShowSurvey && surveyFormValues && (
                <RecentFiltersSidebarItem
                    key="survey"
                    title="Twoje preferencje"
                    filterText={getSurveyFilterText(surveyFormValues)}
                    url={getSurveySearchUrlWithFilters({...recentFiltersLinkConfig, surveyFormValues, latestQuery})}
                />
            )}

            {shouldShow &&
                recentFilters.map((recentFilter, index) => (
                    <RecentFiltersSidebarItem
                        key={`${recentFilter.timestamp}-${index}`}
                        title="Twoje ostatnie filtry"
                        filterText={getRecentFilterFilterText(recentFilter)}
                        url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
                    />
                ))}
        </div>
    );
};

interface RecentFiltersSidebarItemProps {
    title: string;
    filterText: string;
    url: string;
    className?: string;
}

const RecentFiltersSidebarItem = ({title, filterText, url, className}: RecentFiltersSidebarItemProps) => (
    <div className={cx(recentFiltersItemStyle, className)}>
        <div className={recentFiltersTextWrapper}>
            <Text variant="body_copy_1">{title}</Text>
            <Text variant="info_txt_1">{filterText}</Text>
        </div>

        <Button href={url} variant="outlined_secondary" size="x-small" className={recentFiltersButton}>
            użyj
        </Button>
    </div>
);

const recentFiltersListWrapperStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        p: 0
    }
});

const recentFiltersItemStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    justifyContent: "space-between",
    border: "1px solid var(--colors-gray-500)",
    borderRadius: 1,

    md: {
        flexDirection: "row",
        alignItems: "center",
        my: 0
    }
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const recentFiltersButton = css({
    width: "100%",

    md: {
        width: "auto"
    }
});
import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {useOfferListingAbroadView} from "../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {useOfferListingHolidayView} from "../../offer/list/hooks/use_offer_listing_holiday_view_check";
import {useRecentFiltersWithSurvey} from "../hooks/use_recent_filters_with_survey";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {
    getRecentFilterFilterText,
    getRecentFilterSearchUrlWithFilters,
    getSurveyFilterText,
    getSurveySearchUrlWithFilters
} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {}

/**
 * Component to display survey preferences + recent filters from localStorage.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersSidebar = (props: IProps) => {
    const {className, style} = props;

    const {recentFilters, latestQuery, shouldShow, surveyFormValues, shouldShowSurvey, currentFormValues} = useRecentFiltersWithSurvey();

    const isAbroad = useOfferListingAbroadView();
    const isHoliday = useOfferListingHolidayView();

    if (isAbroad || isHoliday) {
        return null;
    }

    const hasAnyContent = (shouldShow && recentFilters.length > 0) || (shouldShowSurvey && !!surveyFormValues);

    if (!hasAnyContent) {
        return null;
    }

    return (
        <div className={cx(recentFiltersListWrapperStyle, className)} style={style}>
            {shouldShowSurvey && surveyFormValues && (
                <RecentFiltersSidebarItem
                    key="survey"
                    title="Twoje preferencje"
                    filterText={getSurveyFilterText(surveyFormValues)}
                    url={getSurveySearchUrlWithFilters({...recentFiltersLinkConfig, surveyFormValues, latestQuery})}
                />
            )}

            {shouldShow &&
                recentFilters.map((recentFilter, index) => (
                    <RecentFiltersSidebarItem
                        key={`${recentFilter.timestamp}-${index}`}
                        title="Twoje ostatnie filtry"
                        filterText={getRecentFilterFilterText(recentFilter)}
                        url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
                    />
                ))}
        </div>
    );
};

interface RecentFiltersSidebarItemProps {
    title: string;
    filterText: string;
    url: string;
    className?: string;
}

const RecentFiltersSidebarItem = ({title, filterText, url, className}: RecentFiltersSidebarItemProps) => (
    <div className={cx(recentFiltersItemStyle, className)}>
        <div className={recentFiltersTextWrapper}>
            <Text variant="body_copy_1">{title}</Text>
            <Text variant="info_txt_1">{filterText}</Text>
        </div>

        <Button href={url} variant="outlined_secondary" size="x-small" className={recentFiltersButton}>
            użyj
        </Button>
    </div>
);

const recentFiltersListWrapperStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        p: 0
    }
});

const recentFiltersItemStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    justifyContent: "space-between",
    border: "1px solid var(--colors-gray-500)",
    borderRadius: 1,

    md: {
        flexDirection: "row",
        alignItems: "center",
        my: 0
    }
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const recentFiltersButton = css({
    width: "100%",

    md: {
        width: "auto"
    }
});
